<div class="availability">
  <small class="availability-title">Disponibilidade por trecho</small>
  <div class="availability-list">
    @for (item of items; track $index) {
      <span class="availability-pill" [class.availability-pill--multi]="items.length > 1"
        [attr.aria-label]="labelFor(item, $index)">
        <span class="availability-leg">
          <span class="availability-flight">LA{{ item.flightNumber }}</span>
          @if (item.originLocationCode && item.destinationLocationCode) {
            <span class="availability-route">&nbsp;({{ item.originLocationCode }}→{{ item.destinationLocationCode }})</span>
          } @else if (item.departure && item.arrival) {
            <span class="availability-route">&nbsp;({{ item.departure }}→{{ item.arrival }})</span>
          }
          <span class="availability-separator" aria-hidden="true">&nbsp;·&nbsp;</span>
        </span>
        <span class="availability-actions">
          <span class="availability-seats">
            <span
              class="availability-dot"
              [class.availability-dot--available]="item.availableSeats !== undefined && item.availableSeats !== null && item.availableSeats > 0"
              [class.availability-dot--empty]="item.availableSeats === 0"
              [class.availability-dot--loading]="item.availableSeats === undefined"
              [class.availability-dot--unavailable]="item.availableSeats === null"
              aria-hidden="true">
            </span>
            @if (countText(item); as count) {
              <strong>{{ count }}</strong><span class="availability-unit">&nbsp;{{ count === 1 ? 'assento' : 'assentos' }}</span>
            } @else if (item.availableSeats === undefined) {
              <strong>Consultando</strong>
            } @else if (item.availableSeats === null) {
              <strong>Indisponível</strong>
            } @else if (item.availableSeats === 0) {
              <strong>Sem assentos</strong>
            } @else {
              <strong>{{ item.availableSeats }} assentos</strong>
            }
          </span>
          @if (item.standbySummary; as standbySummary) {
            <button type="button" class="standby-pill"
              (click)="openStandbyDetail(standbySummary)"
              [attr.aria-label]="standbyTotal(item) + ' Stand by — clique para detalhar'">
              <svg class="standby-pill__icon" width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                <circle cx="9" cy="7" r="4"/>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
              </svg>
              <strong>{{ standbyTotal(item) }}</strong>&nbsp;Stand by
            </button>
          }
        </span>
      </span>
    }
  </div>
</div>
